import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import React from 'react'

import { NotFoundBlock } from 'app/pages/Dashboard/components/NotFoundBlock'

import * as styles from './styles'

import { TitleDescription } from '../../../../../components/TitleDescription'

export const MomentData = (props) => {
  const { momentData } = props

  const formatDateWithDaysBack = (dateString) => {
    if (!dateString) return 'NA'

    const date = dayjs(dateString)
    const now = dayjs()
    const daysDiff = now.diff(date, 'day')

    if (daysDiff === 0) {
      return `today`
    } else if (daysDiff === 1) {
      return `${date.format('D MMM, YY')} (1 day ago)`
    } else {
      return `${date.format('D MMM, YY')} (${daysDiff} days ago)`
    }
  }

  return momentData?.last_moment_received ? (
    <styles.Body>
      <styles.ColumnFlexCenter>
        <styles.InfoBlock>
          <TitleDescription
            heading="Last Moment Received"
            size="small"
            align="center"
            description={formatDateWithDaysBack(
              momentData?.last_moment_received
            )}
          />

          <TitleDescription
            heading="Last Moment Viewed"
            size="small"
            align="center"
            description={formatDateWithDaysBack(momentData?.last_moment_viewed)}
          />
        </styles.InfoBlock>
      </styles.ColumnFlexCenter>
    </styles.Body>
  ) : (
    <NotFoundBlock message="Oh no! No moment's received yet." />
  )
}
